<template>
    <div>
        <el-checkbox @change="changeAccounted" v-model="selectedRow.isAccountant">{{$t('users_tab_hris_rights_accountant')}}</el-checkbox>
        <el-checkbox @change="changeInventoryManager" v-model="selectedRow.isInventoryManager">{{$t('users_tab_hris_rights_inventoryManager')}}</el-checkbox>
        <el-checkbox v-if="selectedRow.isDocumentManager !== null" @change="changeDocumentManager" v-model="selectedRow.isDocumentManager">{{$t('users_tab_hris_rights_documentManager')}}</el-checkbox>
        <el-checkbox @change="changeReceipts" v-model="selectedRow.isChequeReceipts">Cheque Receipts</el-checkbox>
    </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'MyRights',
    components: {

    },
    created() {

    },
    computed: {

    },
    props: ['selectedRow'],
    beforeMount() {

    },
    mounted() {

    },
    data() {
      return {
      }
    },
    methods: {
        changeAccounted(val){
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyUsers/rights?companyId=${this.$route.query.companyId}&companyUserId=${this.selectedRow.userId}&type=accountant&action=${val === true ? 'add' : 'remove'}`)
              .then(response => {
                loader.hide()
                this.$emit('refreshRowData')
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
        },
      changeInventoryManager(val){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUsers/rights?companyId=${this.$route.query.companyId}&companyUserId=${this.selectedRow.userId}&type=inventoryManager&action=${val === true ? 'add' : 'remove'}`)
          .then(response => {
            loader.hide()
            this.$emit('refreshRowData')
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      changeDocumentManager(val) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/users/change-document-manager-status?companyId=${this.$route.query.companyId}&userId=${this.selectedRow.uId}`, {
            isDocumentManager: val
          })
          .then(response => {
            loader.hide()
            this.$emit('refreshRowData')
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      changeReceipts(val) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/companyUsers/rights?companyId=${this.$route.query.companyId}&companyUserId=${this.selectedRow.userId}&type=chequeReceipts&action=${val === true ? 'add' : 'remove'}`)
            .then(response => {
              loader.hide()
              this.$emit('refreshRowData')
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error);
            });
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
